import R from 'ramda';
import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  Checkbox,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/Services';
import { getMemberNameByUserId, getStringFromArray } from '../../utils';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adjust: undefined,
      adjust2: undefined,
      changes: {
        producer: '',
        engineering: false,
        mixing: false,
        production: false,
        masters: '',
        artistName: '',
      },
    };
  }

  options = () => ({
    producer: this.state.changes.producer || '',
    engineering: this.state.changes.engineering || false,
    mixing: this.state.changes.mixing || false,
    production: this.state.changes.production || false,
    masters: this.state.changes.masters || '',
    artistName: this.state.changes.artistName || '',
  });

  oldOptions = () => ({
    producer: this.props.producer || '',
    engineering: this.props.engineering || false,
    mixing: this.props.mixing || false,
    production: this.props.production || false,
    masters: this.props.masters || '',
    artistName: this.props.artistName || '',
  });

  getOptions() {
    const oldOptions = this.oldOptions();
    const options = this.options();

    if (this.state.adjust) {
      oldOptions.producer = options.producer;
    } else if (this.state.adjust === undefined) {
      oldOptions.producer = undefined;
    }

    if (this.state.adjust2) {
      oldOptions.engineering = options.engineering;
      oldOptions.mixing = options.mixing;
      oldOptions.production = options.production;
      oldOptions.masters = options.masters;
      oldOptions.artistName = options.artistName;
    } else if (this.state.adjust === undefined) {
      oldOptions.engineering = undefined;
      oldOptions.mixing = undefined;
      oldOptions.production = undefined;
      oldOptions.masters = undefined;
      oldOptions.artistName = undefined;
    }

    return oldOptions;
  }

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept === undefined ? undefined : !block.accept,
        adjust2: block.accept2 === undefined ? undefined : !block.accept2,
      });
    }
  }

  handleAdjust(adjust, value) {
    const states = this.state;

    states[adjust] = value;
    this.setState(states);

    if (states.adjust === false && states.adjust2 === false) {
      this.props.removeBlockChanges(this.props.block.id);
    } else {
      const { block, agreement } = this.props;
      const options = this.getOptions();

      this.props.setBlockChanges({
        id: block.id,
        options,
        ...getContent(options, agreement.type),
        accept: states.adjust === undefined ? undefined : !states.adjust,
        accept2: states.adjust2 === undefined ? undefined : !states.adjust2,
      });
    }
  }

  handleContent(field, value) {
    const options = this.options();
    options[field] = value;

    if (field === 'engineering' && value === true) {
      options.engineering = true;
    } else if (field === 'mixing' && value === true) {
      options.mixing = true;
    } else if (field === 'production' && value === true) {
      options.production = true;
    } else if (field === 'producer') {
      options.producer = value;
    } else if (field === 'masters') {
      if (value < 0) {
        return;
      }
      options.masters = value;
    } else if (field === 'artistName') {
      options.artistName = value;
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
      accept: this.state.adjust === undefined ? undefined : !this.state.adjust,
      accept2:
        this.state.adjust2 === undefined ? undefined : !this.state.adjust2,
    });
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div>
          <FormGroup className="answer">
            <Select
              className="form-control"
              value={changes.producer}
              onChange={(e) => this.handleContent('producer', e.target.value)}
            >
              <option value="">Please select</option>
              {this.props.dealUsers.map((dealUser, i) => {
                if (dealUser.type === 'member') {
                  let userName = getMemberNameByUserId(
                    dealUser.user,
                    this.props.members
                  );
                  const ownerships = this.props.work.work_ownership_info || [];

                  const ownership = R.find(R.propEq('user', dealUser.user))(
                    ownerships
                  );
                  if (ownership) {
                    if (ownership.use_company_name && ownership.company_name) {
                      userName = userName + ' (' + ownership.company_name + ')';
                    }
                  }
                  return (
                    <option key={i} value={dealUser.user}>
                      {userName}
                    </option>
                  );
                }
                return null;
              })}
            </Select>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderAdjust2() {
    const { adjust2, changes } = this.state;

    if (adjust2 === true) {
      return (
        <div>
          <FormGroup className="answer">
            <Checkbox
              checked={changes.engineering === true}
              readOnly
              onClick={(e) =>
                this.handleContent('engineering', e.target.checked)
              }
            >
              Engineering
            </Checkbox>
            <Checkbox
              checked={changes.mixing === true}
              readOnly
              onClick={(e) => this.handleContent('mixing', e.target.checked)}
            >
              Mixing
            </Checkbox>
            <Checkbox
              checked={changes.production === true}
              readOnly
              onClick={(e) =>
                this.handleContent('production', e.target.checked)
              }
            >
              Production
            </Checkbox>
          </FormGroup>

          <FormGroup className="answer">
            The Producer will produce&nbsp;&nbsp;
            <FormControl
              type="number"
              className="input-sm"
              placeholder="#"
              value={changes.masters}
              onChange={(e) => this.handleContent('masters', e.target.value)}
            />
            &nbsp;&nbsp;master(s) in total that will be performed by&nbsp;
            <FormControl
              type="text"
              placeholder="Enter the name of the performance artist here"
              value={changes.artistName}
              style={{ width: 340 }}
              onChange={(e) => this.handleContent('artistName', e.target.value)}
            />
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { members, work } = this.props;
    let ownerships = work.work_ownership_info || [];

    let content = '';
    if (changeRequest.changes.producer) {
      let producerName = getMemberNameByUserId(
        changeRequest.changes.producer,
        members
      );
      const ownership = R.find(
        R.propEq('user', parseInt(changeRequest.changes.producer, 10))
      )(ownerships);

      if (ownership) {
        if (ownership.use_company_name && ownership.company_name) {
          producerName = producerName + ' (' + ownership.company_name + ')';
        }
      }

      content = producerName;
    }
    return content;
  }

  renderChangeRequest2(changeRequest) {
    let serviceOptions = {
      engineering: changeRequest.changes.engineering,
      mixing: changeRequest.changes.mixing,
      production: changeRequest.changes.production,
    };

    const services = getStringFromArray('services', serviceOptions);
    const content = `${services} service(s) performed by ${changeRequest.changes.artistName}`;
    return content;
  }

  renderChangeRequests(type) {
    let changeRequests = [];
    if (type === 0) {
      changeRequests = this.props.changeRequests;
    } else {
      changeRequests = this.props.changeRequests2;
    }

    return (
      <ChangeRequestsView
        changeRequests={changeRequests}
        renderChangeRequest={(changeRequest) =>
          type === 0
            ? this.renderChangeRequest(changeRequest)
            : this.renderChangeRequest2(changeRequest)
        }
      />
    );
  }

  render() {
    const producerName = getMemberNameByUserId(
      this.props.producer,
      this.props.members
    );

    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">Which collaborator is the Producer?</p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {producerName}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust', true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust()}
              </FormGroup>
              {this.props.renderAccepts()}
              {this.renderChangeRequests(0)}
              <br />

              <p className="question">
                What services will the Producer provide?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust2"
                  checked={this.state.adjust2 === false}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust2', false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.props.content}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust2"
                  checked={this.state.adjust2 === true}
                  readOnly
                  onClick={(e) => this.handleAdjust('adjust2', true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust2()}
              </FormGroup>
              {this.props.renderAccepts2()}
              {this.renderChangeRequests(1)}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  The "services" section is a description of the type of work
                  that will be done to create the master(s). Defining this
                  clears up any confusion about what work should be done.
                </p>
              </div>
              <div className="expand" tabIndex="1">
                <p className="question">What are masters?</p>
                <p className="small">
                  The term “master” usually refers to the original sound
                  recording of a performance from which copies can be made.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Services.jsx